<div class="policy-sensitive-labels">
  <div *ngIf="isLoading()" class="policy-sensitive-labels-spinner">
    <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
  </div>

  <div class="policy-sensitive-labels-header" *ngIf="isLoading() === false">
    <div class="policy-sensitive-labels-header-text">
      {{ 'policyPage.config.sensitiveLabelsContent.description' | labelsProvider }}
    </div>
    <div class="policy-sensitive-labels-count">
      {{ 'policyPage.config.sensitiveLabelsContent.selectedCount' | labelsProvider }}: {{ selectedCount }}
    </div>
  </div>

  <div class="policy-sensitive-labels-body" *ngIf="isLoading() === false">
    <div class="policy-sensitive-labels-body-search">
      <app-autocomplete-search
        class="policy-sensitive-labels-body-search-box"
        placeholder="Search..."
        (autocompleteOnChange)="labelSearched($event)"
        [values]="labelsDisplayNamesForSearch"
        [resetSearchBox$]="resetSearchBoxBehavioralSubject$"
      ></app-autocomplete-search>
    </div>

    <div class="policy-sensitive-labels-body-table">
      <app-table
        [tableColumns]="sensitiveLabelsTableCols"
        [tableRows]="tableRows"
        [isLoading]="isLoading()"
        [isScrollable]="true"
        [withPagination]="true"
        [withCheckbox]="true"
        [withCheckboxAll]="false"
        [pageInfo]="pageInfo$.value"
        [noData]="noData()"
        (checkboxOnClick)="onCheckboxClick($event)"
        (pageOnChange)="onPagination($event)"
      >
      </app-table>
    </div>
  </div>

  @if (editable && isLoading() === false) {
    <app-form-footer
      [changesWereDone]="changesWereDone"
      (resetChanges)="resetForm()"
      (saveChanges)="updatePolicyConfig()"
      (cancelSettings)="cancelSettings()"
    >
    </app-form-footer>
  }
</div>
